export enum SolutionCategoryEnum {
  ALL = 'ALL',
  DOCUMENT_MANAGEMENT_SERVICES = 'Document Management Services',
  BUSINESS_PROCESS_SERVICES = 'Business Process Services',
  INTELLIGENT_AUTOMATION = 'Intelligent Automation',
  DIGITAL_TRANSFORMATION = 'Digital Transformation',
}
